import Color from 'colorjs.io';

/** Minimum contrast ratio for text elements to meet WCAG 2.1 AA. */
export const WCAG_AA_TEXT_CONTRAST_RATIO = 4.5;

export function getContrastRatio(
  color1: string,
  color2: string,
): number | null {
  try {
    return new Color(color1).contrastWCAG21(new Color(color2));
  } catch {
    return null;
  }
}

/**
 * Walks up the DOM from the given element and returns the first non-transparent
 * background color, falling back to white when none is found.
 */
export function getEffectiveBackgroundColor(element: Element | null): string {
  let current: Element | null = element;
  while (current) {
    const backgroundColor = window.getComputedStyle(current).backgroundColor;
    try {
      if (new Color(backgroundColor).alpha > 0) {
        return backgroundColor;
      }
    } catch {
      // Ignore unparseable values and keep walking up the tree.
    }
    current = current.parentElement;
  }
  return 'white';
}
